import moment from "moment";
import { getValidatecARCaNDrARC } from "../../../../redux/grid/action.js";

export const handleWheel = (e) => {
    e.target.blur();
}

const handleKeyAmt = (e) => {
    if (e.keyCode == 38 || e.keyCode == 40) {
        e.preventDefault()
    }
}

export const handleKeyPress = (event) => {
    if (event.keyCode === 13 || event.keyCode == 38 || event.keyCode == 40) {

        event.preventDefault();
    }
};
export const handlePreventEKeyPress = (event) => {

    if (event.keyCode == 69) {
        event.preventDefault();

    }

};


export const removeKeysFromForEobForQDXPatientPay = (claim) => {
    const removeKeyArr = ['claim_copay', 'claim_coins', 'claim_allowed', 'claim_cob', 'claim_deduct', 'claim_patres', 'claim_discount', 'sl_discount', 'sl_allowed', 'sl_deduct', 'sl_coins', 'sl_copay', 'sl_cob', 'sl_patres', 'sl_balance', 'sl_total', 'sl_amount', 'sl_billed', 'sl_paid']
    for (const key of removeKeyArr) {
        delete claim[key];
    }

};

export const preventEFromNumber = (e) => {
    var invalidChars = [
        "-",
        "+",
        "e",
    ];
    if (invalidChars.includes(e.key)) {
        e.preventDefault();
    }
}

export const minValidDate = moment("01/01/1900", "MM/DD/YYYY");

export function preventWhiteSpaceValidate(e) {
    const { value } = e.target; // Get the current value
    if (value.startsWith(' ')) {
        e.target.value = value;
        value = value.trimStart();
    }
    return e
}

export function parseAmount(value,valueType="number") {
     const defaultval = valueType==="number"?"0.00":""
    return isNaN(parseFloat(value)) ? defaultval : parseFloat(value).toFixed(2);
}

export function formatAmountValue(value, valueType = "number") {
    const defaultValue = valueType === "number" ? "0.00" : "";
    
    if (value === ""||value === undefined ) return "";
    
    const parsedValue = parseFloat(value);
    return isNaN(parsedValue) ? defaultValue : parsedValue.toFixed(2);
}   

export const areValuesStrictlyEqual = (formikvalue, apiValue) => {
  
    const parseValue = (val) => {
      
      if (val === "" || val === undefined || val === null || val === NaN ) {
        return "EMPTY"; 
      }
  
      return parseFloat(val) || 0; 
    };
  
    const parsedVal1 = parseValue(formikvalue);
    const parsedVal2 = parseValue(apiValue);
    
    if (parsedVal1 === parsedVal2) {
      return true; 
    }
  
    return false; 
  }
export function isNotNumberOrNumberString(value) {
    return value === true || value === false || value === null || value === '';
}
export function handleAutomationCalculate(claim,qdxTransaction){
        const isServiceLineExist = claim?.service_lines?.length||0
        const isQdxPatientPay = qdxTransaction === "PATIENT_PAY"
        let total = 0;
        let fake_patres = 0;
        let adjustment_total = 0;

        let sl_billed = 0
        let sl_paid = 0
        let sl_discount = 0;
        let sl_allowed = 0
        let sl_deduct = 0
        let sl_coins = 0
        let sl_copay = 0
        let sl_cob = 0
        let sl_balance = 0
        let sl_amount = 0
        let sl_patres = 0
        if (!Array.isArray(claim?.service_lines)) {
            return {
                ...claim,
                sl_discount: 0,
                sl_allowed: 0,
                sl_deduct: 0,
                sl_coins: 0,
                sl_copay: 0,
                sl_cob: 0,
                sl_paid: 0,
                sl_amount: 0,
                sl_balance: 0,
                sl_billed: 0,
                sl_patres: 0,
                claim_billed: 0,
                claim_discount: 0,
                claim_allowed: 0,
                claim_deduct: 0,
                claim_coins: 0,
                claim_copay: 0,
                claim_cob: 0,
                claim_paid: 0,
                claim_balance: 0,
                claim_patres: 0,
            }
        }
        const updatedServiceLines = claim?.service_lines?.map((serviceLine) => {
            let amount_total = 0;
        
            let final_dict = { 
                ...serviceLine,
                sl_discount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_discount),
                sl_allowed : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_allowed),
                sl_deduct : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_deduct),
                sl_coins : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_coins),
                sl_copay : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_copay),
                sl_cob : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_cob),
                sl_amount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.sl_amount),
                sl_billed : parseOrZero(serviceLine?.sl_billed),
                sl_paid : parseOrZero(serviceLine?.sl_paid),
                discount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.discount),
                allowed : isQdxPatientPay?0.00:parseOrZero(serviceLine?.allowed),
                deduct : isQdxPatientPay?0.00:parseOrZero(serviceLine?.deduct),
                coins : isQdxPatientPay?0.00:parseOrZero(serviceLine?.coins),
                copay : isQdxPatientPay?0.00:parseOrZero(serviceLine?.copay),
                cob : isQdxPatientPay?0.00:parseOrZero(serviceLine?.cob),
                amount : isQdxPatientPay?0.00:parseOrZero(serviceLine?.amount),
                adjustments:isQdxPatientPay?[]:serviceLine?.adjustments||[],
                billed : parseOrZero(serviceLine?.billed),
                paid : parseOrZero(serviceLine?.paid),
             };
            // Helper functions for clean calculations
            function safeParse(value) {
                return parseFloat(value) || 0; // Convert to number, default to 0 if NaN
            }
        
            function safeAdd(...values) {
                return values.reduce((acc, val) => acc + safeParse(val), 0).toFixed(2);
            }
        
            // Calculate `amount_total` from adjustments
            amount_total = final_dict?.adjustments?.reduce((sum, adj) => sum + safeParse(adj?.amount), 0) || 0;
        
            // Clone adjustments for current amount calculation
            let current_amount = final_dict?.adjustments ? structuredClone(final_dict.adjustments).reduce((sum, item) => sum + safeParse(item?.amount), 0) : 0;
        
        
            // Summing up service line values safely
            sl_billed = safeAdd(sl_billed, final_dict?.billed);
            sl_discount = safeAdd(sl_discount, final_dict?.discount);
            sl_allowed = safeAdd(sl_allowed, final_dict?.allowed);
            sl_deduct = safeAdd(sl_deduct, final_dict?.deduct);
            sl_coins = safeAdd(sl_coins, final_dict?.coins);
            sl_copay = safeAdd(sl_copay, final_dict?.copay);
            sl_cob = safeAdd(sl_cob, final_dict?.cob);
            sl_paid = safeAdd(sl_paid, final_dict?.paid);
            sl_amount = safeAdd(sl_amount, current_amount);
        
            // Calculate `total_balance`
            const total_balance =
                safeParse(final_dict?.billed) -
                safeParse(final_dict?.discount) -
                safeParse(final_dict?.deduct) -
                safeParse(final_dict?.coins) -
                safeParse(final_dict?.copay) -
                safeParse(final_dict?.cob) -
                safeParse(final_dict?.paid) -
                safeParse(amount_total);
        
            // ================== PATRES ==================
            let total = safeAdd(
                total,
                final_dict?.deduct,
                final_dict?.coins,
                final_dict?.copay
            );
        
            final_dict?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    total = safeAdd(total, adjustment?.amount);
                }
            });
        
            // Calculate `adjustment_total`
            let adjustment_total = final_dict?.adjustments?.reduce((sum, adj) => sum + safeParse(adj?.amount), 0) || 0;
        
            // Calculate `fake_patres`
             fake_patres = safeAdd(
                fake_patres,
                final_dict?.deduct,
                final_dict?.coins,
                final_dict?.copay,
            );
        
            final_dict?.adjustments?.forEach((adjustment) => {
                if (adjustment?.group_code === 'PR') {
                    fake_patres = safeAdd(fake_patres, adjustment?.amount);
                }
            });
        
            // Update `sl_balance`
            sl_balance = safeAdd(sl_balance, total_balance);
        
            // Convert `total_balance` to formatted balance value
            const currentBalance = (parseFloat(total_balance.toFixed(2)) + 0).toFixed(2);
        
            return { ...final_dict,
                discount : toFixedOrEmpty(final_dict?.discount),
                allowed : toFixedOrEmpty(final_dict?.allowed),
                deduct : toFixedOrEmpty(final_dict?.deduct),
                coins : toFixedOrEmpty(final_dict?.coins),
                copay : toFixedOrEmpty(final_dict?.copay),
                cob : toFixedOrEmpty(final_dict?.cob),
                amount : toFixedOrEmpty(final_dict?.amount),
                billed : toFixedOrEmpty(final_dict?.billed),
                paid : toFixedOrEmpty(final_dict?.paid),
                balance: currentBalance 
            };
        });
        sl_patres = fake_patres ?? 0 
        // CLAIM PATRESS
        claim?.claim_adjustments?.forEach((adjustment, ind) => {
            if (adjustment?.group_code == 'PR') {
                fake_patres =
                    parseFloat(fake_patres ? fake_patres : 0) +
                    parseFloat(adjustment?.amount ? adjustment?.amount : 0);
            }
        });


        let sl_total_diff = 0;
        let claim_total_diff = 0;
        let diff = 0;
        const _ = require('lodash');
        sl_total_diff = parseFloat(sl_total_diff ? sl_total_diff : 0) +
            parseFloat(sl_deduct ? sl_deduct : 0) +
            parseFloat(sl_coins ? sl_coins : 0) +
            parseFloat(sl_copay ? sl_copay : 0);


        claim_total_diff = parseFloat(claim_total_diff ? claim_total_diff : 0) +
            parseFloat(sl_deduct ? sl_deduct : 0) +
            parseFloat(sl_coins ? sl_coins : 0) +
            parseFloat(sl_copay ? sl_copay : 0);


        if (Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2)) != parseFloat(0).toFixed(2)) {
            diff = Math.abs(parseFloat(sl_total_diff).toFixed(2) - parseFloat(claim_total_diff).toFixed(2))

        }
        fake_patres = parseFloat(fake_patres ? fake_patres : 0) + parseFloat(diff ? diff : 0);
        claim.adjustment_total = parseFloat(adjustment_total).toFixed(2);
        claim.sl_patres = parseFloat(total).toFixed(2);
        claim.fake_sl_patres = parseFloat(fake_patres).toFixed(2);
        claim.claim_patres = parseFloat(fake_patres).toFixed(2);

        let cl_amount_total = 0;
        claim.claim_adjustments?.map((adjustment, ind) => {
            cl_amount_total = parseFloat(cl_amount_total ? cl_amount_total : 0) + parseFloat(adjustment?.amount ? adjustment?.amount : 0);
        });
        const claim_balance =
            parseFloat(parseFloat(sl_billed ? sl_billed : 0) -
                parseFloat(sl_discount ? sl_discount : 0) -
                parseFloat(sl_deduct ? sl_deduct : 0) -
                parseFloat(sl_coins ? sl_coins : 0) -
                parseFloat(sl_copay ? sl_copay : 0) -
                parseFloat(sl_cob ? sl_cob : 0) -
                parseFloat(sl_paid ? sl_paid : 0) -
                parseFloat(cl_amount_total ? cl_amount_total : 0) -
                parseFloat(sl_amount ? sl_amount : 0)).toFixed(2)
        const sl_balance2 =
            parseFloat(parseFloat(sl_billed ? sl_billed : 0) -
                parseFloat(sl_discount ? sl_discount : 0) -
                parseFloat(sl_deduct ? sl_deduct : 0) -
                parseFloat(sl_coins ? sl_coins : 0) -
                parseFloat(sl_copay ? sl_copay : 0) -
                parseFloat(sl_cob ? sl_cob : 0) -
                parseFloat(sl_paid ? sl_paid : 0) -
                parseFloat(sl_amount ? sl_amount : 0)).toFixed(2)
                
        return {
            ...claim,
            sl_discount: sl_discount,
            sl_allowed: sl_allowed,
            sl_deduct: sl_deduct,
            sl_coins: sl_coins,
            sl_copay: sl_copay,
            sl_cob: sl_cob,
            sl_paid: sl_paid,
            sl_amount: sl_amount,
            sl_balance: sl_balance2,
            sl_billed:sl_billed,
            sl_patres:sl_patres,
            claim_billed: isServiceLineExist===0? parseOrZero(claim?.claim_billed): sl_billed,
            claim_discount: isServiceLineExist===0? parseOrZero(claim?.claim_discount):sl_discount,
            claim_allowed: isServiceLineExist===0? parseOrZero(claim?.claim_allowed):sl_allowed,
            claim_deduct: isServiceLineExist===0? parseOrZero(claim?.claim_deduct):sl_deduct,
            claim_coins: isServiceLineExist===0? parseOrZero(claim?.claim_coins):sl_coins,
            claim_copay: isServiceLineExist===0? parseOrZero(claim?.claim_copay):sl_copay,
            claim_cob: isServiceLineExist===0? parseOrZero(claim?.claim_cob):sl_cob,
            claim_paid: isServiceLineExist===0? parseOrZero(claim?.claim_paid):sl_paid,
            claim_balance: isServiceLineExist===0? parseOrZero(claim?.claim_balance):claim_balance,
            service_lines: updatedServiceLines,


        };
    }
export function getAutoationColordataId(data){
const claims= data?.claims?.map((claim,claimIndex)=>({
    ...claim,
    init_automation_color_id:claimIndex,
    service_lines : claim?.service_lines?.length>0 
                    ? claim?.service_lines?.map((serviceLine,servicelineIndex)=>({
                        ...serviceLine,
                        init_automation_color_id:servicelineIndex,
                        adjustments :serviceLine?.adjustments?.length>0 
                                    ?  serviceLine?.adjustments.map((adj,adjIndex)=>({
                                    ...adj,
                                    init_automation_color_id:adjIndex,
                                    })):[]
                    })) :[]
}))
data.claims = claims
return data 
}

export function isValidDate(dateStr) {
    if (!dateStr) return false;
    const date = new Date(dateStr);
    return date instanceof Date && !isNaN(date.getTime());
  }

  
  export function getPeriodDates(serviceLines) {
    if (!Array.isArray(serviceLines) || serviceLines.length === 0) {
      return { period_start: "", period_end: "" };
    }
  
    let minDate = null;
    let maxDate = null;
  
    serviceLines.forEach(({ from_date, to_date }) => {
      const fromDate = new Date(from_date);
      const toDate = new Date(to_date);
  
      if (!isNaN(fromDate.getTime())) {
        if (!minDate || fromDate < minDate) minDate = fromDate;
      }
  
      if (!isNaN(toDate.getTime())) {
        if (!maxDate || toDate > maxDate) maxDate = toDate;
      }
    });
  
    const period_start = minDate ? moment(minDate).format("MM/DD/YYYY") : "";
    const period_end = maxDate ? moment(maxDate).format("MM/DD/YYYY") : "";
  
    return { period_start, period_end };
  }
  function parseOrZero(value) {
    if (value === "" || value === undefined || value === null) {
        return "";
    }

    if (typeof value === "number") {
        return isNaN(value) ? 0 : value;
    }

    if (typeof value === "string") {
        const dotCount = (value.match(/\./g) || []).length;
        if (dotCount > 1) return 0;

        const parsed = parseFloat(value);
        return isNaN(parsed) ? 0 : parsed;
    }

    return 0;
}
export function createData837(data) {

    // Check if data and header_color_data are valid objects
    if (!data || typeof data !== 'object' || !data?.header_color_data || typeof data?.header_color_data !== 'object') {
        return [];
    }

    const result = {};
    let hasAnyTrue = false;
    const header = data?.header_color_data;

    for (const key in header) {
        if (header[key] === true && key in data && data[key] !== undefined && data[key] !== null) {
            result[key] = data[key];
            hasAnyTrue = true
        }
    }
    if (hasAnyTrue) {
        result.automation837pull = true;
    }

    return [result];
}

export function createClaim837Data(claim) {
    const result = {};
    let hasAnyTrue = false;
    if (!claim || typeof claim !== 'object' || !claim?.claims_colour_data || typeof claim?.claims_colour_data !== 'object') {
        return [];
    }
    // Safe access to claims_colour_data
    const claimsColorData = claim?.claims_colour_data || {};

    for (const key in claimsColorData) {
        if (claimsColorData[key] && key in claim) {
            result[key] = claim[key];
            hasAnyTrue = true
        }
    }
    if (hasAnyTrue) {
        result.automation837pull = true;
    }

    // Handle service lines safely

    return result;
}

export function createServiceLine837Data(serviceline) {
    const result = {};
    let hasAnyTrue = false;
    if (!serviceline || typeof serviceline !== 'object' || !serviceline?.sl_colour_data || typeof serviceline?.sl_colour_data !== 'object') {
        return [];
    }
    // Safe access to sl_colour_data
    const claimsColorData = serviceline?.sl_colour_data || {};

    for (const key in claimsColorData) {
        if (claimsColorData[key] && key in serviceline) {
            result[key] = serviceline[key];
            hasAnyTrue = true
        }
    }

    if (hasAnyTrue) {
        result.automation837pull = true;
    }

    // Handle service lines safely

    return result;
}
  
function toFixedOrEmpty(value) {
    if (value === "" || value === undefined || value === null) {
        return "";
    }
    if (typeof value === "number") {
        return isNaN(value) ? "" : value.toFixed(2);
    }
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? "" : parsed.toFixed(2);
    }
    return "";
}
export function checkWhetherNumberIsEqual(a,b) {
    return (a == null || a === "undefined") && (b == null || b === "undefined") || (a === "" && b === "")
    ? false // No difference if both are null/undefined or both are empty strings
    : (a === "" || b === "") 
      ? true // If one is empty string and the other isn't, they are different
      : Number(a) !== Number(b);
}
// debounce util
export const customeDebounce = (func, delay = 500) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };
  
  // validation function
  export const validateRarcCarcCode = async (isRarcCarcValidData,setIsRarcCarcValidData,qdx_status, search1, type, name, currentFormik, is_papercode = false) => {
    if (qdx_status === 'INCOMPLETE') return;
    const search = search1.toUpperCase()
    if (!search?.length) return;
    if(isRarcCarcValidData[type]?.includes(search)) {
         currentFormik.setFieldValue(name,'')
      return;
    }
    const isValidCARC = (value) => /^[a-zA-Z0-9]{0,3}$/.test(value);
    const isValidRARC = (value) => /^[A-Za-z][A-Za-z0-9]{0,4}$/.test(value) && /[0-9]/.test(value);
  
    const shouldCallApi =
      (type === 'CARC' && isValidCARC(search)) ||
      (type === 'RARC' && isValidRARC(search));
  
    if (!shouldCallApi) return;
    currentFormik.setFieldValue(name,`Invalid ${type}`)
    await getValidatecARCaNDrARC(search, type)((response) => {
      if (response?.status_code === 200) {
        currentFormik.setFieldValue(name, response?.status ? '' : `Invalid ${type}`);
        response?.status&&setIsRarcCarcValidData(prev => {
            if (prev[type].includes(search)) return prev
            return { ...prev, [type]: [...prev[type], search] }
          })
      }
    });
  };
  

export function generateAutomationUniqueId(index,jobData){
    let uniqueId = index
    if(jobData?.is_large_batch_job&&jobData?.is_worked===false){
        const subJobNum = jobData?.file_info?.job_unique_id?.split('-')[1]
        uniqueId = `${subJobNum}-${index}`
    }
    return uniqueId
}
export function getAutomationUniqueId(index,jobData){
    let uniqueId = index
    if(jobData?.is_large_batch_job){
        const subJobNum = uniqueId?.split('-')[1]
        uniqueId = Number(subJobNum)
    }
    return uniqueId
}


export const sequestrationServicelineAdjustmentValidation = (serviceLine,adjustment)=>{
    const percent = 2
    function safeParse(value) {
        return parseFloat(value) || 0; // Convert to number, default to 0 if NaN
    }

    function safeAdd(...values) {
        return values.reduce((acc, val) => acc + safeParse(val), 0).toFixed(2);
    }

    let total = safeAdd(
        serviceLine?.deduct,
        serviceLine?.coins,
        serviceLine?.copay
    );

    serviceLine?.adjustments?.forEach((adjustment) => {
        if (adjustment?.group_code === 'PR') {
            total = safeAdd(total, adjustment?.amount);
        }
    });

    const result = (parseFloat(serviceLine.allowed??0) - total) * (percent / 100);
    const rounded = Math.round(result * 100) / 100;
    const isValid = parseFloat(rounded) == parseFloat(adjustment.amount??0)
    return !isValid
}
export const sequestrationClaimsAdjustmentValidation = (claim,adjustment)=>{
    const percent = 2
    function safeParse(value) {
        return parseFloat(value) || 0; // Convert to number, default to 0 if NaN
    }

    function safeAdd(...values) {
        return values.reduce((acc, val) => acc + safeParse(val), 0).toFixed(2);
    }

    let total = safeAdd(
        claim?.claim_deduct,
        claim?.claim_coins,
        claim?.claim_copay
    );

    claim?.claim_adjustments?.forEach((adjustment) => {
        if (adjustment?.group_code === 'PR') {
            total = safeAdd(total, adjustment?.amount);
        }
    });

    const result = (parseFloat(claim.claim_allowed??0) - total) * (percent / 100);
    const rounded = Math.round(result * 100) / 100;
    const isValid = parseFloat(rounded) == parseFloat(adjustment.amount??0)
    return !isValid
}
export const isIndexFileDataExist = (jobData, formik, name) => {
  const indexValue = jobData?.grid_data?.loaded_from_index?.[name];
    // console.log(jobData,'jobData',name)
    // console.log(formik?.values,'formik?.values',name)
  // If the index value is null, undefined, or an empty string, treat as non-existent
  if (indexValue === null || indexValue === undefined || indexValue === '') {
    return false;
  }

  const formikValue = formik?.values?.[name];
    const normalize = (val) => {
    
    if (!isNaN(val) && val !== '') {
      return Number(val);
    }
    
    return String(val).toUpperCase();
  };

  return normalize(formikValue) === normalize(indexValue);

  
};